'use client';

import Loader from '@pickleballinc/features/src/Loader/Loader';

export default function Loading() {
	return <Loader backgroundColor="bg-[#EF6820] opacity-100" />;
}
